var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownloadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66536 10.8282C1.86137 10.29 1.33203 9.37347 1.33203 8.33333C1.33203 6.77095 2.52637 5.48753 4.05186 5.34625C4.36391 3.44809 6.01219 2 7.9987 2C9.9852 2 11.6335 3.44809 11.9455 5.34625C13.471 5.48753 14.6654 6.77095 14.6654 8.33333C14.6654 9.37347 14.136 10.29 13.332 10.8282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 11.3333L7.9987 14M7.9987 14L10.6654 11.3333M7.9987 14L7.9987 8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadCloud);
export default __webpack_public_path__ + "static/media/IconDownloadCloud.290431da87467208de8b11800f426339.svg";
export { ForwardRef as ReactComponent };